<template><div><h1 id="teilnehmerliste-fur-veranstaltungen" tabindex="-1"><a class="header-anchor" href="#teilnehmerliste-fur-veranstaltungen"><span>Teilnehmerliste für Veranstaltungen</span></a></h1>
<p>Teilnehmerliste für Veranstaltungen — Drucken einer Teilnehmerliste</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Drucken einer Adressliste der Teilnehmer, die den eingegebenen Parametern entsprechen</p>
<p>Pfad: <code v-pre>Veranstaltungen → Datenausgabe → Teilnehmerliste</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Jahr/Nummer von</dt>
<dd>Identifikator der Veranstaltung (kleinster)</dd>
<dt>Jahr/Nummer bis</dt>
<dd>Identifikator der Veranstaltung (grösster)</dd>
<dt>Anmeldestatus</dt>
<dd>Anmeldestatus (<span class="quote">„<span class="quote">leer</span>“</span> = alle)</dd>
<dt>Berücksichtigt:</dt>
<dd>Status: <span class="guilabel">j</span> = Berücksichtigte Anmeldungen, <span class="guilabel">n</span> = Nicht berücksichtigte Anmeldungen und <span class="quote">„<span class="quote">leer</span>“</span> = alle</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Landscape)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Name</td>
<td>Name</td>
</tr>
<tr>
<td>Vorname</td>
<td>Vorname</td>
</tr>
<tr>
<td>PLZ</td>
<td>Postleitzahl</td>
</tr>
<tr>
<td>Ort</td>
<td>Ort</td>
</tr>
<tr>
<td>Strasse+Nr</td>
<td>Strasse und Hausnummer</td>
</tr>
<tr>
<td>GebDat.</td>
<td>Geburtsdatum</td>
</tr>
<tr>
<td>Telefon</td>
<td>Telefonnummer</td>
</tr>
<tr>
<td>E-Mail</td>
<td>E-Mail Adresse (falls vorhanden)</td>
</tr>
</tbody>
</table>
<pre><code>                             Veranstaltung
</code></pre>
<p>Jahr/Nr: 2001/18   Preis: 380.00    Alter.: 18-99 Anzahl:   1- 20 30.01.01 dku
von-bis: 06.10.2001-13.10.2001      Anm.: P   0 D  15 B  13 T  12
Bezeich: Lagerleitung im Umweltbereich
Leitung:  3'433'146 Künzler Daniel, Zürich 8004, Eichbühlstr Tel: 01/4935867</p>
<p>Name                 Vorname         PLZ  Ort             Strasse+Nr                GebDat.    Telefon      E-Mail</p>
<hr>
<p>Meyer                Thys            4057 Basel           Horburgstrasse 40         08.09.1972
Hösli                Tania           8617 Mönchaltorf     Im Heugarten 21           13.07.1983 01/9480716   bifdus@yahoo.com
Gartenmann           Peter           8522 Häuslenen       Im Zentrum /A             01.08.1965</p>
</div></template>


